import styled, { css } from 'styled-components';

import BlockTitle from '../../global/typography/BlockTitle';

const mobileMixin = css`
  @media ${p => p.theme.media.largePhone} {
    display: none;
  }
`;

export default styled(BlockTitle)`
  font-family: ${p => p.theme.font.sourceSans};
  font-weight: 600;
  margin-bottom: 30px;

  ${p => p.hideOnMobile && mobileMixin};
`;
